<script>
import NavBar from '@components/nav-bar'
import FooterBar from '@components/footer-bar'
import SideBar from '@components/side-bar'
import RightBar from '@components/right-bar'

export default {
  components: { NavBar, FooterBar, SideBar, RightBar },
  data() {
    return {
      isMenuCondensed: false,
      user: this.$store ? this.$store.state.auth.currentSession.user : {} || {},
    }
  },
  watch: {
    isMenuCondensed(newVal, oldVal) {
      localStorage.setItem('isMenuCondensed', newVal);
    }
  },
  created: () => {
    document.body.style.backgroundColor = '';
    document.body.classList.remove('authentication-bg')
    document.body.classList.remove('authentication-bg-pattern')
  },
  methods: {
    toggleMenu(action=null) {
      if (!document.body.classList.contains('sidebar-enable') || action === true){
        this.isMenuCondensed = true
        document.body.classList.add('enlarged')
        document.body.classList.add('sidebar-enable')
        localStorage.setItem('isMenuCondensed', 'true')
      } else {
        this.isMenuCondensed = false
        document.body.classList.remove('enlarged')
        document.body.classList.remove('sidebar-enable')
        localStorage.setItem('isMenuCondensed', 'false')
      }
    },
    toggleRightSidebar() {
      document.body.classList.toggle('right-bar-enabled')
    }
  },
  mounted(){
    if (localStorage.getItem('isMenuCondensed') === 'true'){
      this.toggleMenu(true)
    }
  }
}
</script>

<template>
  <div id="wrapper">
    <NavBar :user="user" />
    <SideBar :is-condensed="isMenuCondensed" />
    <!-- ============================================================== -->
    <!-- Start Page Content here -->
    <!-- ============================================================== -->

    <div class="content-page">
      <div class="content">
        <!-- Start Content-->
        <div class="container-fluid p-1">
          <slot />
        </div>
      </div>
    </div>
    <FooterBar class="d-none" />
  </div>
</template>
